export default __webpack_public_path__ + "static/media/SaveProspectGrey.b78b865a.svg";